import App from "src/app";

export { Page };

function Page() {
  return <App />;
}
